import { createApp } from 'vue'
import App from './App.vue'

import Personnummer from "./components/Personnummer/Personnummer";
import KontonummerValidator from "./components/KontonummerValidator";
import Person from "./components/Person/Person";

const app = createApp(App)
app.component('personnummer', Personnummer)
app.component('kontonummer-validator', KontonummerValidator)
app.component('person', Person)
app.mount('#app')

